module.exports = __webpack_public_path__ + "img/pick3.f19d2612.png";